/**
 * 停車場／場內充電站資料來源（畫面用）
 */

const EV_SOURCE_FALLBACK_ZH = Object.freeze({
    TDX: '交通部運輸資料流通平台（充電站）',
    OCM: 'Open Charge Map（開放充電地圖）',
    OSM: 'OpenStreetMap',
    TESLA_SCI: 'Tesla Supercharger（supercharge.info）',
    NTPC_EPA: '新北市政府環境保護局開放資料',
    TXG_EPA: '臺中市政府環境保護局開放資料',
    TYN_OPEN: '桃園市政府經濟發展局開放資料'
});

export function parkingProvenanceSummaryZh(provenance) {
    const labels = Array.isArray(provenance?.labels_zh)
        ? provenance.labels_zh.map((s) => String(s || '').trim()).filter(Boolean)
        : [];
    if (labels.length) return labels.join('、');
    return '停車場開放資料';
}

export function evStationSourceLabelZh(stationOrProps) {
    const p = stationOrProps || {};
    if (p.source_label) return String(p.source_label);
    const labels = p.h_data_provenance?.labels_zh || p.labels_zh;
    if (Array.isArray(labels) && labels[0]) return String(labels[0]);
    const src = p.h_source || p.source || '';
    return EV_SOURCE_FALLBACK_ZH[src] || src || '';
}

export function formatParkingUpdatedHkt(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const hkt = new Date(d.getTime() + 8 * 60 * 60 * 1000);
    const pad = (n) => String(n).padStart(2, '0');
    return `${hkt.getUTCFullYear()}-${pad(hkt.getUTCMonth() + 1)}-${pad(hkt.getUTCDate())} ${pad(hkt.getUTCHours())}:${pad(hkt.getUTCMinutes())}（HKT）`;
}

export function formatParkingProvenanceLines(provenance, opts = {}) {
    const lines = [`資料來源：${parkingProvenanceSummaryZh(provenance)}`];
    const at = provenance?.updated_at || opts.updatedAt || '';
    const hkt = formatParkingUpdatedHkt(at);
    if (hkt) lines.push(`更新時間：${hkt}`);
    return lines;
}
